import React from 'react';
import { observer } from 'mobx-react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import classes from './CustomerStatus.module.scss';
import { SCAN_IQ_CUSTOMER_STATUS } from '../../../../../../interfaces/ScanIqCustomerStatus';
import { Status } from '../../../../../../../shared/components/ui-components';
import { scanIqCustomerProfileStore } from '../../../../../../stores/scanIqCustomerProfileStore';
import { getFormattedDate } from '../../../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../../../shared/constants/apiDateFormat';

const CustomerStatus = observer(() => {
  const { customerProfileInfo } = scanIqCustomerProfileStore;

  const { status, subscriptionExpire } = customerProfileInfo || {};

  switch (status) {
    case SCAN_IQ_CUSTOMER_STATUS.ACTIVE:
      return (
        <Status icon={<CheckCircleRoundedIcon fontSize="small" color="success" />}>
          Active
        </Status>
      );
    case SCAN_IQ_CUSTOMER_STATUS.ACTIVE_ONE_TIME:
      return (
        <Status icon={<CheckCircleRoundedIcon fontSize="small" color="success" />}>
          <div className={classes.statusWithDescription}>
            Active <span className={classes.description}>(until the end of today)</span>
          </div>
        </Status>
      );
    case SCAN_IQ_CUSTOMER_STATUS.CANCELED:
      return (
        <Status icon={<CancelRoundedIcon fontSize="small" color="error" />}>
          <div className={classes.statusWithDescription}>
            Canceled&nbsp;
            {subscriptionExpire && (
              <span className={classes.description}>
                Active to {getFormattedDate(subscriptionExpire, localDataFormat)}
              </span>
            )}
          </div>
        </Status>
      );
    case SCAN_IQ_CUSTOMER_STATUS.PAYMENT_ISSUE:
      return (
        <Status icon={<WarningRoundedIcon fontSize="small" color="warning" />}>
          Payment Issue
        </Status>
      );
    case SCAN_IQ_CUSTOMER_STATUS.INACTIVE_ONE_TIME:
    case SCAN_IQ_CUSTOMER_STATUS.INACTIVE:
      return (
        <Status icon={<CancelRoundedIcon fontSize="small" color="error" />}>
          Inactive
        </Status>
      );
    case SCAN_IQ_CUSTOMER_STATUS.PENDING:
      return (
        <Status icon={<WarningRoundedIcon fontSize="small" color="warning" />}>
          Incomplete
        </Status>
      );
    default:
      return null;
  }
});

export { CustomerStatus };
